import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

export const performed = colors.statusCompleted;

const useStyles = makeStyles({
  performedChart: {
    boxShadow: 'none',
    width: '100%',
    '& > div': {
      '& path:last-of-type': {
        strokeDasharray: '1',
      },
    },
    marginTop: '10px',
  },
  isLoading: {
    color: colors.lightGray,
  },
  tooltipContainer: {
    '& > div:first-of-type': {
      background: colors.gray,
      color: colors.white,
    },
    '& > div:last-of-type::after': {
      background: colors.gray,
    },
  },
  noData: {
    display: 'grid',
    height: '250px',
    color: colors.gray,
    alignContent: 'center',
    justifyContent: 'center',
    justifyItems: 'center',
    margin: '10% 50%',

    '& p': {
      width: '300px',
      display: 'flex',
      justifyContent: 'center',
    },
  },
  barLabel: {
    color: colors.chartLegend,
    fontWeight: fonts.weights.medium,
    fontSize: fonts.sizes.xxsmall,
    letterSpacing: '1.5px',
    lineHeight: '16px',
    marginLeft: '8px',
  },
});

export default useStyles;
